'use client';

import { useState } from 'react';
import UpgradeNowModal from './UpgradeNowModal';
import UpgradeNowMobileModal from './UpgradeNowMobileModal';
import { isMobile } from '@util/index';
import { usePathname } from 'next/navigation';
import { useRouter } from '@bprogress/next';
import { useAuth } from 'context/AuthContext';

type UpgradeNowTriggerProps = {
  title?: string;
};

export default function UpgradeNowTrigger({
  title = 'Upgrade Now',
}: UpgradeNowTriggerProps) {
  const [open, setOpen] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  const { userDoc } = useAuth();
  const pathname = usePathname();
  const router = useRouter();

  const onOpenChange = () => {
    if (pathname === '/') {
      router.push('/boot-trade-in-program');
    } else {
      if (userDoc) {
        if (isMobile()) {
          setOpenMobile(true);
        } else {
          setOpen(!open);
        }
      } else {
        router.push('/login');
      }
    }
  };

  return (
    <>
      <button
        type="button"
        className="h-[5rem] rounded-[1.5rem] bg-brand-secondary px-8 py-2 text-[1.8rem] font-medium text-white transition-colors duration-150 ease-out hover:bg-brand-secondary-darker"
        onClick={onOpenChange}
      >
        {title}
      </button>

      <UpgradeNowModal open={open} setOpen={setOpen} />
      <UpgradeNowMobileModal open={openMobile} setOpen={setOpenMobile} />
    </>
  );
}
